import axios from 'axios';
import {toast} from 'react-toastify';

export const api = axios.create({
    // baseURL:'http://localhost:8016',
     baseURL:'http://api-termo.passefacil.com.br',
    
})

export default api;